import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ReportsBarChartComponent = ({ reportsData }) => {

  const getStatusColor = (status) => {
    switch (status) {
      case 'Draft': return '#F44336';
      case 'Preliminary': return '#0c8597';
      case 'Finalized': return '#4CAF50';
      default: return '#9E9E9E';
    }
  };

  const chartData = Object.entries(reportsData).map(([status, count]) => ({
    name: status,
    y: count,
    color: getStatusColor(status),
  }));

  const options = {
    chart: {
      type: 'column',
      backgroundColor: null,
    },
    title: {
      text: '',
    },
    plotOptions: {
      column: {
        pointWidth: 50,
        borderWidth: 0
      }
    },
    xAxis: {
      categories: Object.keys(reportsData),
      title: {
        text: 'Report Status',
        style: {
          color: 'white'
        }
      },
      labels: {
        style: {
          color: 'white'
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Number of Reports',
        style: {
          color: 'white'
        }
      },
      labels: {
        style: {
          color: 'white'
        }
      },
      tickInterval: 10,
      allowDecimals: false
    },
    tooltip: {
      pointFormat: '{point.y} reports',
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: 'Reports',
        data: chartData,
        showInLegend: false,
      },
    ],
    credits: {
      enabled: false,
    }
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ReportsBarChartComponent;
